import type { JSX } from 'react';

import { SUPPORTED_PAYERS } from '../../config/supported-payers.js';

export function PayerSelect({
  id,
  value,
  onChange,
}: {
  id: string;
  /** Selected GROUP id (not payer id — four groups share `BCNC`). */
  value: string;
  onChange: (groupId: string) => void;
}): JSX.Element {
  return (
    <select
      id={id}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="rounded-xl border border-[var(--color-field-border)] bg-white px-4 py-2.5 text-[var(--ink)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--coral)]"
    >
      <option value="">Select your health plan…</option>
      {SUPPORTED_PAYERS.map((p) => (
        <option key={p.groupId} value={p.groupId}>
          {p.label}
        </option>
      ))}
    </select>
  );
}
